import { isPatientPortalPartnerPage } from '@/components/routes/utils';
import { SESSION_STORAGE_KEY } from '@/hooks/patient/refill/persistedOrderDetails';
import { getPersistedIsExternal } from '@/hooks/usePersistIsExternal';
import { LOGIN_ROUTE } from '@/routes/route-paths';
import { Logger } from '@/utils/logger';
import { viteDomainSplitBaseUrl } from '@montugroup/circuit-shared/constants/env';
import { AuthService, AuthServiceImpl } from '@montugroup/circuit-shared/services/authentication.service';

const logger = new Logger('authentication.service');

export class CustomerPortalAuthService extends AuthServiceImpl {
  async clearUserDataFromStorage() {
    await super.clearUserDataFromStorage();
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  }

  redirectToLogin({ reason }: { reason: 'expired' | 'deactivation' | 'manual' } = { reason: 'manual' }) {
    const localStorageIsExternal = getPersistedIsExternal();
    const loginPath = reason === 'expired' ? `${LOGIN_ROUTE}/?expired=true` : LOGIN_ROUTE;

    // NOTE: We default to the customer-portal /login for first time access (AKA `null`)
    // For unauthenticated users accessing /patient/orders or /patient/refill, redirect to the Patient Portal Login
    if (
      (localStorageIsExternal === null && !isPatientPortalPartnerPage(window.location.pathname)) ||
      localStorageIsExternal === 'true'
    ) {
      return super.redirectToLogin({ reason });
    }
    const redirectURL = `${viteDomainSplitBaseUrl('patient')}${loginPath}`;
    logger.info(`running redirectToLogin ${localStorageIsExternal}`, {
      redirectURL,
    });
    window.location.href = redirectURL;
  }
}

// Overwrite AuthService methods with customer portal specific implementations
AuthService.clearUserDataFromStorage = CustomerPortalAuthService.prototype.clearUserDataFromStorage.bind(AuthService);
AuthService.redirectToLogin = CustomerPortalAuthService.prototype.redirectToLogin.bind(AuthService);
